type Path = string | Array<string | number>;
type GetFunctionType = {
    <ObjectType, ReturnType>(obj: ObjectType, path: Path, defaultValue?: ReturnType): ReturnType;
    <ReturnType>(obj: unknown, path: Path, defaultValue?: ReturnType): ReturnType;
};

export const get: GetFunctionType = <ObjectType, ReturnType>(
    obj: ObjectType,
    path: Path,
    defaultValue?: ReturnType,
): ReturnType | undefined => {
    if (!path || path.length === 0) {
        return undefined;
    }

    // @ts-expect-error unknown key of object
    const valueOfWholePath = obj && obj[path];

    if (!Array.isArray(path) && obj && valueOfWholePath !== undefined) {
        return valueOfWholePath;
    }

    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g) || [''];

    const pathValue = pathArray.reduce(
        // @ts-expect-error unknown key of object
        (prevObj, key) => (prevObj ? prevObj && prevObj[key] : undefined),
        obj,
    ) as ReturnType | undefined;

    return pathValue === undefined ? defaultValue : pathValue;
};
